// import Highcharts from 'highcharts';
import Highcharts from '../Highcharts';
import HighchartsReact from 'highcharts-react-official';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useState } from 'react';
import { useEffect } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .highcharts-root': {
        fontFamily: 'Poppins !important'
      },
      '& .highcharts-drilldown-axis-label': {
        textDecoration: 'none !important',
        fill: 'var(--grayLv3) !important',
        fontWeight: '400 !important'
      },
      '& .highcharts-label text': {
        textDecoration: 'none !important',
        fill: 'var(--grayLv3) !important',
        fontWeight: '500 !important'
      },
      '& .highcharts-label tspan': {
        fontSize: '2rem'
      }
    },    
  }),
);

const initialOptions = {
  chart: {
    height: 240,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'pie'
  },
  title: {
    text: 'Portas Abertas',
    x: 0,
    y: 20,        
  },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.y}</b>'
  },
  accessibility: {
    point: {
      valueSuffix: '%'
    }
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: true,
        format: '<b>{point.y}</b>'
      },
      showInLegend: true,
      // dataLabels: {
      //   enabled: true,
      //   format: '<b>{point.name}</b>: {point.y}'
      // }
    },
  },
  credits: {
    enabled: false
  },  
  series: [
    {
      // colorByPoint: true,
      name: '02/08 à 08/08',
      data: [
        {
          name: 'Após Retirada',
          y: 12,
          // sliced: true,
          // selected: true
        },
        {
          name: 'Após Entrega',
          y: 20
        }
      ]
    }]
}

interface ChartProps {
  data: {
    series: any,
  },
  period: number
}

export default function Pie({ data, period }: ChartProps) {
  const [options, setOptions] = useState(initialOptions)
  const classes = useStyles();

  

  useEffect(() => {
    const selectedPeriod = data.series.filter((x: any) => x.id === period);
      
    setOptions(
      {
        ...options,
        series: selectedPeriod.length > 0 ? selectedPeriod : data.series[3],
      });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, period]);

  return (
    <div className={classes.root}>
      <HighchartsReact highcharts={Highcharts} options={options} />    
    </div>
  )
}